<i *ngIf="snackBarType == 'success-snackbar'" class="fa-solid fa-circle-check snackbar-icon"></i>
<i *ngIf="snackBarType == 'error-snackbar'" class="fa-solid fa-circle-xmark snackbar-icon"></i>
<i *ngIf="snackBarType == 'warning-snackbar'" class="fa-solid fa-triangle-exclamation snackbar-icon"></i>
<span>{{data}} </span>

  